module.exports = __webpack_public_path__ + "img/WLF.cdf62a57.svg";